import {
    getAdditionalUserInfo,
    OAuthProvider,
    signInWithCredential,
    signInWithPopup,
    updateProfile,
    UserCredential
} from "firebase/auth";
import {auth} from "../../firebaseConfig";
import {appleAuthHelpers, AppleAuthResponse} from "react-apple-signin-auth";
import {APP_CLIENT_ID} from "../constants";
import {captureMessage} from "../sentry";

export const signInWithFirebasePopUp = async () => {
    const provider = new OAuthProvider("apple.com")
    provider.addScope("email")
    provider.addScope("name")
    await signInWithPopup(auth, provider);
}

export const signInWithAppleLibrary = async () => {
    const appleAuthResponse = await appleAuthHelpers.signIn({
        authOptions: {
            clientId: APP_CLIENT_ID,
            redirectURI: `${window.origin}/__/auth/handler`,
            scope: "email name",
            state: "state",
            usePopup: true,
        },
        onError: (error: unknown) => {
            if (!(error instanceof Error)) {
                // Wrap non-Error values in an Error object
                throw new Error(JSON.stringify(error));
            }
            throw error;
        }
    });

    if (!appleAuthResponse?.authorization) {
        throw new Error("No authorization response");
    }

    const appleCredential = new OAuthProvider("apple.com").credential({
        idToken: appleAuthResponse.authorization.id_token,
    });

    const userCredential = await signInWithCredential(auth, appleCredential);
    const additionalInfo = getAdditionalUserInfo(userCredential);
    const isNewUser = additionalInfo?.isNewUser;

    if (isNewUser) {
        await createUserDisplayName(appleAuthResponse, userCredential);
    }
}

const createUserDisplayName = async (appleAuthResponse: AppleAuthResponse, userCredential: UserCredential) => {
    try {
        const {user} = appleAuthResponse;
        const firstName = user?.name?.firstName ?? "";
        const lastName = user?.name?.lastName ?? "";
        const fullName = (firstName + " " + lastName).trim();

        if (fullName) {
            await updateProfile(userCredential.user, {displayName: fullName});
        }
    } catch (error) {
        captureMessage(`createUserDisplayName: ${error}`, 'warning');
    }
}